import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

function DoughnutChart({data}) {
  ChartJS.register(ArcElement, Tooltip, Legend);

  const options = {
    plugins: {
      tooltip: {
        titleFont: {
          family: "IRANSans",
          size: 10,
        },
        bodyFont: {
          family: "IRANSans",
          size: 10,
        },
        footerFont: {
          family: "IRANSans",
          size: 10,
        }
      },
      legend: {
        // rtl: true,
        labels: {
          font: {
            family: "IRANSans",
            size: 12,
          },
        },
      },
    },
  }

  // const data = {
  //   labels: ["کشویی", "لولایی", "ترکیبی"],
  //   datasets: [
  //     {
  //       data: [12, 19, 3],
  //       backgroundColor: ["#cb93ee", "#47cec0", "#5c9def"],
  //       borderWidth: 3,
  //     },
  //   ],
  // };

  return (
    <div className="p-3">
      <Doughnut 
        data={data}
        options={options}
      />
    </div>
  );
}

export default DoughnutChart;
